/**
 * Formula configuration utilities
 */

interface FormulaConfig {
  hideDiscounts?: boolean;
  hideCategoryDiamonds?: boolean;
  hideSalesOnDeals?: boolean;
  hideHotelFilters?: boolean;
  hideRestaurantFilters?: boolean;
}

declare global {
  interface Window {
    FORMULA_CONFIG?: FormulaConfig;
  }
}

/**
 * Check if discounts should be hidden based on formula settings
 */
export function hideDiscounts(): boolean {
  return window.FORMULA_CONFIG?.hideDiscounts === true;
}

/**
 * Check if category diamonds should be hidden based on formula settings
 */
export function hideCategoryDiamonds(): boolean {
  return window.FORMULA_CONFIG?.hideCategoryDiamonds === true;
}

/**
 * Check if sales should be hidden on deals based on formula settings
 */
export function hideSalesOnDeals(): boolean {
  return window.FORMULA_CONFIG?.hideSalesOnDeals === true;
}

/**
 * Check if hotel filters should be hidden based on formula settings
 */
export function hideHotelFilters(): boolean {
  return window.FORMULA_CONFIG?.hideHotelFilters === true;
}

/**
 * Check if restaurant filters should be hidden based on formula settings
 */
export function hideRestaurantFilters(): boolean {
  return window.FORMULA_CONFIG?.hideRestaurantFilters === true;
}
